import React from 'react';
import { Link } from 'react-router-dom';
import { Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';
import {
  getImgBig,
  getSmallImg,
  getUserLink,
  decodeSpecLetters,
} from '../../Utility/utility';
// import parse from 'html-react-parser';

import profile from 'static/img/profile/profile.svg';
import { fixHttps } from 'app/components/Utility/coreFunctions';

const styleAvatar = {
  width: '100%',
  height: '100%',
  lineHeight: '46px',
  fontSize: 26,
};

function PreviewBigImage(props) {
  const getImageBig = getImgBig(props.previewJson);
  const images = getSmallImg(props.previewJson);
  const { scope = null } = props;

  let { owner = {} } = props.previewJson;
  owner = !owner ? {} : owner;
  const { avatar = {}, name = '', id = 0 } = owner;

  return (
    <div className="tourPreviewBodyImgBig" style={scope ? { width: 177 } : {}}>
      <div className="big-image-shadow" />
      <div className="mainImg">
        {!scope ? (
          <img src={props.previewJson.map_tour_image} alt="t" />
        ) : (
          getImageBig
        )}
      </div>
      {!scope ? (
        <div className="secondImgs">
          {props.previewJson.images && props.previewJson.images.length > 0
            ? images
            : getImageBig}
        </div>
      ) : null}
      {props.previewJson.owner && !props.fetching ? (
        <div className="addImage">
          <Link to={getUserLink({ name, id })}>
            <>
              <img
                src={fixHttps(avatar?.fullpath) || profile}
                alt="img"
                style={styleAvatar}
              />
              <div className="ownerLink">
                <FormattedMessage id="by" defaultMessage="by" />
                <>:</>
                <span style={{ marginLeft: 3 }}>{decodeSpecLetters(name)}</span>
              </div>
            </>
          </Link>
        </div>
      ) : null}
    </div>
  );
}

PreviewBigImage.propTypes = {};

export default PreviewBigImage;
